import Styles from './BannerContent.module.scss'

interface Props {
  heading: string
  text: string
}

const Button = ({ heading, text }: Props) => {
  return (
    <div className={Styles.bannerContent}>
      <header className={Styles.heading}>{heading}</header>
      <p className={Styles.text}>{text}</p>
    </div>
  )
}
export default Button
